import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import Select from "material-ui/Select";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import Checkbox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import Tabs, { Tab } from "material-ui/Tabs";
import Switch from "material-ui/Switch";
import Grid from "material-ui/Grid";
import Radio, { RadioGroup } from "material-ui/Radio";
import List, { ListItem, ListItemText } from "material-ui/List";
import { toast } from "react-toastify";

import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormLabel
} from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

import { validateFormData } from "../../../common/formtool";

import generateNames from "../../../common/namegenerate";

import { CUSTOM_METADATA_STANDARD } from "../../../common/constants";

class EditFiberTests extends React.Component {
  constructor(props) {
    super(props);
    const { job } = props;
    (this.state = {
      editSaving: false,
      open: true,
      boolValue: [
        {
          id: true,
          name: "Yes"
        },
        {
          id: false,
          name: "No"
        }
      ],
      allowEditMaxLength: true,
      allowApplyLength: true,
      errors: {},
      tabs: [],
      tabPosition: 0,
      test: {
        jobid: job.id,
        name: "",
        // "floor": '',
        // "telecommunicationspace": '',
        // "panel": '',

        fibercablebrand: "", //
        fibercablebrandid: "", // int

        fibercabletype: "", //
        fibercabletypeid: "", // int

        cableid: "", // string
        refractiveindex: 1.49, //int
        limitmethodtype: "", //int
        limitmethodtypename: "", //

        groupid: "", // string
        standardid: "", // string
        adapterscount: 2,
        splicecount: 0,
        illosswllow: 0,
        illosswlhigh: 0,

        applicationid: "", //int
        applicationname: "",

        limitwavelength: "", // int
        limitwavelengthname: "", // string

        cordlosstype: { id: 1 },
        adapterloss: 0.75,
        spliceloss: 0.3,
        measurelength: false,
        callimitlength: false,
        maxlength: 1000, //

        testmode: "",
        testmodeid: "", //int
        direction: "",
        directionid: "",
        jumperid: "",
        jumpers: "",
        flux: "",
        connectortype: "",
        metadata: [
          {
            level: "1",
            value: "",
            field: job.level1,
            default: job.level1 !== "",
            enabled: job.level1 !== ""
          },
          {
            level: "2",
            value: "",
            field: job.level2,
            default: job.level2 !== "",
            enabled: job.level2 !== ""
          },
          {
            level: "3",
            value: "",
            field: job.level3,
            default: job.level3 !== "",
            enabled: job.level3 !== ""
          },
          {
            level: "4",
            value: "",
            field: job.level4,
            default: job.level4 !== "",
            enabled: job.level4 !== ""
          },
          {
            level: "5",
            value: "",
            field: job.level5,
            default: job.level5 !== "",
            enabled: job.level5 !== ""
          },
          {
            level: "6",
            value: "",
            field: job.level6,
            default: job.level6 !== "",
            enabled: job.level6 !== ""
          }
        ]
      },
      disabledToogleIdentifier: false,
      cablebrands: [],
      cabletypes: [],
      cableparts: [],
      appDetails: [],
      stdDetails: [],
      disbleBudgetLossMin: false,
      disbleBudgetLossMax: false,
      disableRefractiveIndex: true,
      hasResult: false,
      testHasResultWithMetaData: false,
      findreplacetestnames: false,
      addchangeengineer: false,
      nearfarconnector: false,
      findName: "",
      replaceName: "",
      engineerName: "",
      modalRef: React.createRef()
    }),
      (this.budgetLossMin = "850nm");
    this.budgetLossMax = "1300nm";
    this.cableType = "";
  }

  editTestDetails = e => {
    if (
      [
        "findreplacetestnames",
        "addchangeengineer",
        "nearfarconnector"
      ].includes(e.target.name)
    ) {
      this.setState({ [e.target.name]: !this.state[e.target.name] });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  handleTabChange = (event, value) => {
    let { tabPosition } = this.state;
    let prevTabClicked = tabPosition > value;
    let allowTabChange = prevTabClicked ? true : this.validate();
    if (allowTabChange) {
      this.setState({ tabPosition: value });
    }
  };

  tabNext() {
    let check = this.canTabNext();
    let validate = this.validate();
    if (validate && check.can) this.setState({ tabPosition: check.pos });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  tabBack() {
    let check = this.canTabBack();
    if (check.can) this.setState({ tabPosition: check.pos });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  canTabNext() {
    const { tabs, tabPosition } = this.state;
    let pos = tabPosition + 1;
    return pos < tabs.filter(n => n).length
      ? { can: true, pos: pos }
      : { can: false, pos: pos };
  }

  canTabBack() {
    const { tabPosition } = this.state;
    let pos = tabPosition - 1;
    return pos >= 0 ? { can: true, pos: pos } : { can: false, pos: pos };
  }

  tabsComplete() {
    const { tabs, tabPosition } = this.state;
    return tabPosition === tabs.filter(n => n).length - 1 ? true : false;
  }

  handleClose = () => {
    this.setState({
      open: false
    });
    this.props.cancel("cancel");
  };

  setInsertionLoss = () => {
    const { fiberStandards } = this.props;
    const { test } = this.state;

    let cabletype = fiberStandards.cablebrands;
    let typeDetails = cabletype.find(x => x.id === test.cablebrand.id)
      .cabletypedetails;
    let partdetailsObj = typeDetails.find(x => x.id === test.cabletype.id)
      .cablepartdetails;
    partdetailsObj;
  };

  onChange = (e, isObj, cableTypes) => {
    let test = { ...this.state.test };
    let errors = { ...this.state.errors };
    let {
      cabletypes,
      cableparts,
      cablebrands,
      fiberappgroups,
      fiberstdgroups,
      wavelengthdetails,
      wavelengths,
      disbleBudgetLossMin,
      disbleBudgetLossMax,
      allowEditMaxLength,
      allowApplyLength,
      disableRefractiveIndex,
      appDetails,
      stdDetails
    } = this.state;
    const { fiberStandards } = this.props;

    errors = {
      ...errors,
      [e.target.name]: false
    };
    const { job, translate, lengthMeasurementUnit } = this.props;
    let value;

    if (e.target.name === "cablebrand") {
      cabletypes = cablebrands
        ? cablebrands.find(x => x.id === e.target.value)
        : null;
      if (cabletypes.name.toLowerCase().includes("generic")) {
        disableRefractiveIndex = false;
      } else {
        disableRefractiveIndex = true;
      }
      cabletypes =
        cabletypes && cabletypes.cabletypedetails
          ? cabletypes.cabletypedetails
          : null;
      if (test[e.target.name] && test[e.target.name].id !== e.target.value) {
        test.cablepart = "";
        test.cabletype = "";
        test.refractiveindex = 1.49;
        cableparts = [];
      }
    }

    if (e.target.name === "cabletype") {
      cableparts = cabletypes
        ? cabletypes.find(x => x.id === e.target.value)
        : null;
      this.cableType = cableparts ? cableparts.type : null;
      cableparts = cableparts ? cableparts.cablepartdetails : null;
      if (test[e.target.name] && test[e.target.name].id !== e.target.value) {
        test.cablepart = "";
        test.refractiveindex = 1.49;
      }
      test.flux = test.flux && this.cableType !== "SM" ? test.flux : false;

      const cableObj = {
        id: e.target.value,
        name: e.nativeEvent.target.outerText
          ? e.nativeEvent.target.outerText.trim()
          : e.nativeEvent.target.innerText
          ? e.nativeEvent.target.innerText
          : ""
      };
      test[e.target.name] = cableObj;

      // filter wavelengths value based on cableType (Sm/ Mm)
      if (
        test.limitmethodtype &&
        [
          "Manual Loss Budget",
          "Loss Budget Calculator",
          "Applications"
        ].includes(test.limitmethodtype.name)
      ) {
        if (this.cableType) {
          let wavelengthDetails = wavelengthdetails
            ? wavelengthdetails.find(x => x.cabletype === this.cableType)
            : null;
          wavelengths =
            wavelengthDetails && wavelengthDetails.wavelength
              ? wavelengthDetails.wavelength
              : [];
          if (e.target.value != 1) {
            test.limitwavelength =
              wavelengthDetails && wavelengthDetails.wavelength
                ? wavelengthDetails.wavelength.find(x => x.id === 2)
                : null;
          }
          if (wavelengthDetails && wavelengthDetails.wavelengthvalue) {
            let waveLengthValue = wavelengthDetails.wavelengthvalue;
            this.budgetLossMin = waveLengthValue[0];
            this.budgetLossMax = waveLengthValue[1];
          }
          test.callimitlength = true;
          test.measurelength = true;
          allowApplyLength = false;
          allowEditMaxLength = false;
          test.illosswllow = "";
          test.illosswlhigh = "";
          disbleBudgetLossMin = false;
          disbleBudgetLossMax = false;
        }
      }

      if (
        test.limitmethodtype &&
        test.cabletype &&
        test.limitmethodtype.name == "Cabling Standards"
      ) {
        // filter groups based on cabletypeName when limit method type is cabling standard
        fiberstdgroups = fiberStandards.stdgroups;
        fiberstdgroups = fiberstdgroups.filter(standardDetailsObj => {
          let o = standardDetailsObj.standarddetails.filter(obj => {
            let m = obj.lengthdetails.filter(
              o =>
                o.name === test.cabletype.name &&
                (o.length != null ||
                  o.lossbudgetlow != null ||
                  o.lossbudgethigh != null)
            );
            if (m.length) {
              return true;
            } else {
              return false;
            }
          });
          if (o.length) {
            return true;
          } else {
            return false;
          }
        });
      }

      if (
        test.limitmethodtype &&
        test.cabletype &&
        test.limitmethodtype.name == "Applications"
      ) {
        // filter groups based on cabletypeName when limit method type is application
        fiberappgroups = fiberStandards.appgroups;
        fiberappgroups = fiberappgroups.filter(applicationDetailsObj => {
          let o = applicationDetailsObj.applications.filter(obj => {
            let m = obj.lengthdetails.filter(
              o =>
                o.name === test.cabletype.name &&
                (o.length != null ||
                  o.lossbudgetlow != null ||
                  o.lossbudgethigh != null)
            );
            if (m.length) {
              return true;
            } else {
              return false;
            }
          });
          if (o.length) {
            return true;
          } else {
            return false;
          }
        });
      }

      if (test.standard != null && typeof test.standard === "object") {
        let standarddDetails = fiberstdgroups
          ? fiberstdgroups.find(x => x.id === test.group.id)
          : null;
        if (!standarddDetails) {
          test.standard = "";
          test.maxlength = "";
          test.illosswlhigh = "";
          test.illosswllow = "";
          test.group = "";
        } else {
          // filter standards based on cabletypeName
          if (
            standarddDetails &&
            standarddDetails.standarddetails &&
            test.cabletype.name
          ) {
            standarddDetails = standarddDetails.standarddetails.filter(obj => {
              let m = obj.lengthdetails.filter(
                o =>
                  o.name === test.cabletype.name &&
                  (o.length != null ||
                    o.lossbudgetlow != null ||
                    o.lossbudgethigh != null)
              );
              if (m.length) {
                return true;
              } else {
                return false;
              }
            });
            stdDetails = standarddDetails ? standarddDetails : [];
          }

          standarddDetails = stdDetails.find(x => x.id === test.standard.id);
          if (!standarddDetails) {
            test.standard = "";
            test.maxlength = "";
            test.illosswlhigh = "";
            test.illosswllow = "";
          } else {
            let maxObj =
              standarddDetails && standarddDetails.lengthdetails
                ? standarddDetails.lengthdetails.find(
                    x => x.name === test.cabletype.name
                  )
                : {};
            test.maxlength = maxObj && maxObj.length ? maxObj.length : "";
            test.maxlength =
              test.maxlength &&
              (lengthMeasurementUnit == "feet"
                ? Math.round((test.maxlength / 0.3048) * 100) / 100
                : test.maxlength);
            test.illosswllow =
              maxObj && maxObj.lossbudgetlow ? maxObj.lossbudgetlow : "";
            test.illosswlhigh =
              maxObj && maxObj.lossbudgethigh ? maxObj.lossbudgethigh : "";
          }
        }
      }

      if (test.application != null && typeof test.application === "object") {
        let applicationDetails = fiberappgroups
          ? fiberappgroups.find(x => x.id === test.group.id)
          : null;
        if (!applicationDetails) {
          test.application = "";
          test.maxlength = "";
          test.illosswlhigh = "";
          test.illosswllow = "";
          test.group = "";
        } else {
          // filter applications based on cabletypeName
          if (
            applicationDetails &&
            applicationDetails.applications &&
            test.cabletype.name
          ) {
            applicationDetails = applicationDetails.applications.filter(obj => {
              let m = obj.lengthdetails.filter(
                o =>
                  o.name === test.cabletype.name &&
                  (o.length != null ||
                    o.lossbudgetlow != null ||
                    o.lossbudgethigh != null)
              );
              if (m.length) {
                return true;
              } else {
                return false;
              }
            });
            appDetails = applicationDetails ? applicationDetails : [];
          }

          applicationDetails = appDetails.find(
            x => x.id === test.application.id
          );
          if (!applicationDetails) {
            test.application = "";
            test.maxlength = "";
            test.illosswlhigh = "";
            test.illosswllow = "";
          } else {
            let lossObj =
              applicationDetails && applicationDetails.lengthdetails
                ? applicationDetails.lengthdetails.find(
                    x => x.name === test.cabletype.name
                  )
                : {};
            test.maxlength = lossObj && lossObj.length ? lossObj.length : "";
            test.maxlength =
              test.maxlength &&
              (lengthMeasurementUnit == "feet"
                ? Math.round((test.maxlength / 0.3048) * 100) / 100
                : test.maxlength);
            test.illosswllow =
              lossObj && lossObj.lossbudgetlow ? lossObj.lossbudgetlow : "";
            test.illosswlhigh =
              lossObj && lossObj.lossbudgethigh ? lossObj.lossbudgethigh : "";
          }
        }
      }
    }

    if (e.target.name === "cablepart") {
      let cablePart = cableparts
        ? cableparts.find(x => x.id === e.target.value)
        : null;
      if (test[e.target.name] && test[e.target.name].id !== e.target.value) {
        test.refractiveindex = 1.49;
      }
      test.refractiveindex = this.cableType
        ? this.cableType.toLowerCase() == "mm"
          ? cablePart.rihigh
          : cablePart.rilow
        : 1.49;
    }

    if (e.target.name === "limitmethodtype") {
      if (test[e.target.name] && test[e.target.name].id !== e.target.value) {
        test["measurelength"] = false;
        test["callimitlength"] = false;
        test["maxlength"] = lengthMeasurementUnit == "feet" ? 3280.84 : 1000;
        test["group"] = "";
        test["standard"] = "";
        test["application"] = "";
        test["spliceloss"] = 0.3;
        test["adapterloss"] = 0.75;
        test["adapterscount"] = 2;
        test["splicecount"] = 0;
        test["illosswllow"] = 0;
        test["illosswlhigh"] = 0;
        test["limitwavelength"] = "";
        test["cordlosstype"] = { id: 0 };
        disbleBudgetLossMin = false;
        disbleBudgetLossMax = false;
        // if applications and loss budget calculator
        if ([1, 2, 3].includes(e.target.value)) {
          if (this.cableType) {
            let wavelengthDetails = wavelengthdetails
              ? wavelengthdetails.find(x => x.cabletype === this.cableType)
              : null;
            wavelengths =
              wavelengthDetails && wavelengthDetails.wavelength
                ? wavelengthDetails.wavelength
                : [];
            if (e.target.value != 1) {
              test.limitwavelength =
                wavelengthDetails && wavelengthDetails.wavelength
                  ? wavelengthDetails.wavelength.find(x => x.id === 2)
                  : null;
            }
            if (wavelengthDetails && wavelengthDetails.wavelengthvalue) {
              let waveLengthValue = wavelengthDetails.wavelengthvalue;
              this.budgetLossMin = waveLengthValue[0];
              this.budgetLossMax = waveLengthValue[1];
            }
            test.callimitlength = true;
            test.measurelength = true;
            allowApplyLength = false;
            allowEditMaxLength = false;
          }
        } else {
          test.callimitlength = false;
          test.measurelength = false;
          allowApplyLength = true;
          allowEditMaxLength = true;
        }

        // if cabling standard and manual loss budget selected in limit method type
        if ([0, 3].includes(e.target.value)) {
          test.adapterscount = "2";
          test.splicecount = "0";
        }

        // filter groups based on cabletypeName  when limit method type is cabling standard
        if ([0].includes(e.target.value)) {
          fiberstdgroups = fiberstdgroups.filter(standardDetailsObj => {
            let o = standardDetailsObj.standarddetails.filter(obj => {
              let m = obj.lengthdetails.filter(
                o =>
                  o.name === test.cabletype.name &&
                  (o.length != null ||
                    o.lossbudgetlow != null ||
                    o.lossbudgethigh != null)
              );
              if (m.length) {
                return true;
              } else {
                return false;
              }
            });
            if (o.length) {
              return true;
            } else {
              return false;
            }
          });
        }

        // filter groups based on cabletypeName when limit method type is application
        if ([1].includes(e.target.value)) {
          fiberappgroups = fiberappgroups.filter(applicationDetailsObj => {
            let o = applicationDetailsObj.applications.filter(obj => {
              let m = obj.lengthdetails.filter(
                o =>
                  o.name === test.cabletype.name &&
                  (o.length != null ||
                    o.lossbudgetlow != null ||
                    o.lossbudgethigh != null)
              );
              if (m.length) {
                return true;
              } else {
                return false;
              }
            });
            if (o.length) {
              return true;
            } else {
              return false;
            }
          });
        }
      }
    }

    if (e.target.name === "limitwavelength") {
      if (this.cableType) {
        wavelengths = wavelengthdetails
          ? wavelengthdetails.find(x => x.cabletype === this.cableType)
          : null;
        if (wavelengths && wavelengths.wavelengthvalue) {
          let waveLengthValue = wavelengths.wavelengthvalue;
          this.budgetLossMin = waveLengthValue[0];
          this.budgetLossMax = waveLengthValue[1];
        }
      }
      wavelengths = wavelengths.wavelength;
      if (wavelengths) {
        if (e.target.value === 0) {
          (disbleBudgetLossMin = false), (disbleBudgetLossMax = true);
          delete errors["illosswllow"];
          test.illosswlhigh = "";
        } else if (e.target.value === 1) {
          (disbleBudgetLossMin = true), (disbleBudgetLossMax = false);
          delete errors["illosswlhigh"];
          test.illosswllow = "";
        } else {
          disbleBudgetLossMin = false;
          disbleBudgetLossMax = false;
          delete errors["illosswllow"];
          delete errors["illosswlhigh"];
        }
      }
    }

    if (e.target.name === "group") {
      if (
        test.limitmethodtype &&
        test.cabletype &&
        test.limitmethodtype.name == "Cabling Standards"
      ) {
        let standarddDetails = fiberstdgroups
          ? fiberstdgroups.find(x => x.id === e.target.value)
          : null;
        if (
          standarddDetails &&
          standarddDetails.standarddetails &&
          test.cabletype.name
        ) {
          standarddDetails = standarddDetails.standarddetails.filter(obj => {
            let m = obj.lengthdetails.filter(
              o =>
                o.name === test.cabletype.name &&
                (o.length != null ||
                  o.lossbudgetlow != null ||
                  o.lossbudgethigh != null)
            );
            if (m.length) {
              return true;
            } else {
              return false;
            }
          });
          stdDetails = standarddDetails ? standarddDetails : [];
        }
      }

      if (
        test.limitmethodtype &&
        test.cabletype &&
        test.limitmethodtype.name == "Applications"
      ) {
        let applicationDetails = fiberappgroups
          ? fiberappgroups.find(x => x.id === e.target.value)
          : null;
        if (
          applicationDetails &&
          applicationDetails.applications &&
          test.cabletype.name
        ) {
          applicationDetails = applicationDetails.applications.filter(obj => {
            let m = obj.lengthdetails.filter(
              o =>
                o.name === test.cabletype.name &&
                (o.length != null ||
                  o.lossbudgetlow != null ||
                  o.lossbudgethigh != null)
            );
            if (m.length) {
              return true;
            } else {
              return false;
            }
          });
          appDetails = applicationDetails ? applicationDetails : [];
        }
      }

      if (test[e.target.name] && test[e.target.name].id !== e.target.value) {
        test["application"] = "";
        test["standard"] = "";
        test["illosswllow"] = "";
        test["illosswlhigh"] = "";
        test["maxlength"] = "";
      }
    }

    if (e.target.name === "standard") {
      if (e.target.value && test.cabletype.name) {
        let lengthDetails = stdDetails.find(x => x.id === e.target.value);
        let maxObj =
          lengthDetails && lengthDetails.lengthdetails
            ? lengthDetails.lengthdetails.find(
                x => x.name === test.cabletype.name
              )
            : {};
        test.maxlength = maxObj && maxObj.length ? maxObj.length : "";
        test.maxlength =
          test.maxlength &&
          (lengthMeasurementUnit == "feet"
            ? Math.round((test.maxlength / 0.3048) * 100) / 100
            : test.maxlength);
        test.illosswllow =
          maxObj && maxObj.lossbudgetlow ? maxObj.lossbudgetlow : "";
        test.illosswlhigh =
          maxObj && maxObj.lossbudgethigh ? maxObj.lossbudgethigh : "";
      }
    }

    if (e.target.name === "application") {
      if (e.target.value && test.cabletype.name) {
        let lengthDetails = appDetails.find(x => x.id === e.target.value);
        let lossObj =
          lengthDetails && lengthDetails.lengthdetails
            ? lengthDetails.lengthdetails.find(
                x => x.name === test.cabletype.name
              )
            : {};
        test.maxlength = lossObj && lossObj.length ? lossObj.length : "";
        test.maxlength =
          test.maxlength &&
          (lengthMeasurementUnit == "feet"
            ? Math.round((test.maxlength / 0.3048) * 100) / 100
            : test.maxlength);
        test.illosswllow =
          lossObj && lossObj.lossbudgetlow ? lossObj.lossbudgetlow : "";
        test.illosswlhigh =
          lossObj && lossObj.lossbudgethigh ? lossObj.lossbudgethigh : "";
      }
    }

    if (isObj) {
      if (value) {
        test[e.target.name] = value;
      } else {
        let tempObj = {};
        tempObj.id = e.target.value;
        tempObj.name = e.nativeEvent.target.outerText
          ? e.nativeEvent.target.outerText.trim()
          : e.nativeEvent.target.innerText
          ? e.nativeEvent.target.innerText
          : "";
        test[e.target.name] = tempObj;
      }
    } else {
      test[e.target.name] = e.target.value;
    }

    this.setState({
      test,
      errors,
      allowApplyLength,
      allowEditMaxLength,
      cabletypes,
      cableparts,
      cablebrands,
      wavelengths,
      disbleBudgetLossMin,
      disbleBudgetLossMax,
      disableRefractiveIndex,
      stdDetails,
      appDetails,
      fiberappgroups,
      fiberstdgroups
    });
  };

  onLenghtLimitChange = e => {
    let test = { ...this.state.test };
    let { allowApplyLength, allowEditMaxLength } = this.state;
    if (e.target.name === "measurelength") {
      if (test["measurelength"] === false) {
        allowApplyLength = false;
      } else {
        allowApplyLength = true;
        test.callimitlength = false;
        test.maxlength = "";
        allowEditMaxLength = true;
      }
      test.measurelength = !test.measurelength;
    }
    if (e.target.name === "callimitlength") {
      test.maxlength = e.target.value === "true" ? "" : test["maxlength"];
      test.callimitlength = !test.callimitlength;
      allowEditMaxLength = !allowEditMaxLength;
    }

    this.setState({ test, allowEditMaxLength, allowApplyLength });
  };

  onToggleChange = (e, checked) => {
    let test = { ...this.state.test };
    test[e.target.name] = checked;
    this.setState({ test: test });
  };

  onCustomCheckChange = e => {
    let test = { ...this.state.test };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let enabled = !metadataOption.enabled;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      enabled: enabled,
      field: document.querySelector(`select[name="${e.target.name}"]`).value
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  };

  onCustomChange = e => {
    let test = { ...this.state.test };

    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let field = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      field
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  };

  onChangeMetadataField = e => {
    let { test, errors } = { ...this.state };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let value = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      value
    };
    errors[e.target.name] = false;
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test, errors });
  };

  validate = currentTab => {
    const {
      test,
      tabPosition,
      disbleBudgetLossMin,
      disbleBudgetLossMax,
      hasResult,
      disableRefractiveIndex,
      testHasResultWithMetaData,
      findreplacetestnames,
      addchangeengineer,
      nearfarconnector,
      findName,
      replaceName,
      engineerName
    } = this.state;
    const { job, translate, multiple, lengthMeasurementUnit } = this.props;
    let validationData = {};
    let errors = {};
    if (hasResult && !multiple) {
      if (tabPosition === 0 || currentTab === 0) {
        validationData = {
          name: {
            required: translate("formfield_error_general_required"),
            type: {
              value: "alphanumericspecial",
              message: translate("formfield_error_general_type_alphanumeric")
            }
          }
        };
      } else if (tabPosition === 1 || currentTab === 1) {
        if (findreplacetestnames) {
          validationData = {
            findName: {
              required: translate("formfield_error_general_required")
            }
          };
        }
        if (addchangeengineer) {
          validationData["engineerName"] = {
            required: translate("formfield_error_general_required")
          };
        }
      } else if (
        testHasResultWithMetaData &&
        (tabPosition === 2 || currentTab === 2)
      ) {
        test.metadata.map(x => {
          if (x.enabled && (x.value === null || x.value.trim() === "")) {
            errors[x.level] = true;
          } else if (x.enabled && x.value.length > 12) {
            errors[x.level] = true;
          }
        });
      }
    } else {
      switch (currentTab || currentTab === 0 ? currentTab : tabPosition) {
        case 0:
          if (!multiple) {
            validationData = {
              name: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "alphanumericspecial",
                  message: translate(
                    "formfield_error_general_type_alphanumeric"
                  )
                }
              }
            };
          } else {
            if (findreplacetestnames) {
              validationData = {
                findName: {
                  required: translate("formfield_error_general_required")
                }
              };
            }
            if (addchangeengineer) {
              validationData["engineerName"] = {
                required: translate("formfield_error_general_required")
              };
            }
          }
          break;
        case 1:
          validationData = {
            cablebrand: {
              required: translate("formfield_error_general_required")
            },
            cabletype: {
              required: translate("formfield_error_general_required")
            },
            cablepart: {
              required: translate("formfield_error_general_required")
            },
            refractiveindex: {
              required: translate("formfield_error_general_required"),
              type: {
                value: "decimal",
                message: translate("should_be_atmost_two_place_decimal_digit")
              }
            },
            limitmethodtype: {
              required: translate("formfield_error_general_required")
            }
          };
          if (!disableRefractiveIndex) {
            validationData.refractiveindex.range = {
              minValue: 1.3,
              maxValue: 1.55,
              message: translate("fiber_test_refractiveindex_out_of_range_desc")
            };
          }
          break;
        case 2:
          if (test.limitmethodtype.name === "Applications") {
            validationData = {
              cordlosstype: {
                required: translate("formfield_error_general_required")
              },
              group: {
                required: translate("formfield_error_general_required")
              },
              application: {
                required: translate("formfield_error_general_required")
              }
            };
          }

          if (test.limitmethodtype.name === "Cabling Standards") {
            validationData = {
              cordlosstype: {
                required: translate("formfield_error_general_required")
              },
              group: {
                required: translate("formfield_error_general_required")
              },
              standard: {
                required: translate("formfield_error_general_required")
              },
              adapterscount: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "numeric",
                  message: translate("formfield_error_general_type_numeric")
                },
                range: {
                  minValue: 2,
                  maxValue: 8,
                  message: translate("fiber_test_noofadapter_out_of_range_desc")
                }
              },
              splicecount: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "numeric",
                  message: translate("formfield_error_general_type_numeric")
                },
                range: {
                  minValue: 0,
                  maxValue: 8,
                  message: translate("fiber_test_noofslice_out_of_range_desc")
                }
              }
            };
          }

          if (test.limitmethodtype.name === "Loss Budget Calculator") {
            validationData = {
              limitwavelength: {
                required: translate("formfield_error_general_required")
              },
              cordlosstype: {
                required: translate("formfield_error_general_required")
              },
              adapterscount: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "numeric",
                  message: translate("formfield_error_general_type_numeric")
                },
                range: {
                  minValue: 2,
                  maxValue: 8,
                  message: translate("fiber_test_noofadapter_out_of_range_desc")
                }
              },
              splicecount: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "numeric",
                  message: translate("formfield_error_general_type_numeric")
                },
                range: {
                  minValue: 0,
                  maxValue: 8,
                  message: translate("fiber_test_noofslice_out_of_range_desc")
                }
              },
              adapterloss: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "decimal",
                  message: translate("should_be_atmost_two_place_decimal_digit")
                },
                range: {
                  minValue: 0,
                  maxValue: 5,
                  message: translate("fiber_test_adapterloss_out_of_range_desc")
                }
              },
              spliceloss: {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "decimal",
                  message: translate("should_be_atmost_two_place_decimal_digit")
                },
                range: {
                  minValue: 0,
                  maxValue: 5,
                  message: translate("fiber_test_spliceloss_out_of_range_desc")
                }
              }
            };
            if (!disbleBudgetLossMin) {
              validationData["illosswllow"] = {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "decimal",
                  message: translate("should_be_atmost_two_place_decimal_digit")
                },
                range: {
                  minValue: 0,
                  maxValue: 5,
                  message: translate("fiber_test_iloss_out_of_range_desc")
                }
              };
            }
            if (!disbleBudgetLossMax) {
              validationData["illosswlhigh"] = {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "decimal",
                  message: translate("should_be_atmost_two_place_decimal_digit")
                },
                range: {
                  minValue: 0,
                  maxValue: 5,
                  message: translate("fiber_test_iloss_out_of_range_desc")
                }
              };
            }
            if (test.measurelength && test.callimitlength) {
              validationData["maxlength"] = {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "decimal",
                  message: translate("should_be_atmost_two_place_decimal_digit")
                },
                range: {
                  minValue: 0,
                  maxValue: lengthMeasurementUnit == "feet" ? 131233.6 : 40000,
                  message:
                    lengthMeasurementUnit == "feet"
                      ? translate("fiber_test_maxlength_out_of_range_desc_feet")
                      : translate("fiber_test_maxlength_out_of_range_desc")
                }
              };
            }
          }

          if (test.limitmethodtype.name === "Manual Loss Budget") {
            validationData = {
              limitwavelength: {
                required: translate("formfield_error_general_required")
              },
              cordlosstype: {
                required: translate("formfield_error_general_required")
              }
            };
            if (!disbleBudgetLossMin) {
              validationData["illosswllow"] = {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "decimal",
                  message: translate("should_be_atmost_two_place_decimal_digit")
                },
                range: {
                  minValue: 0,
                  maxValue: 5,
                  message: translate("fiber_test_iloss_out_of_range_desc")
                }
              };
            }
            if (!disbleBudgetLossMax) {
              validationData["illosswlhigh"] = {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "decimal",
                  message: translate("should_be_atmost_two_place_decimal_digit")
                },
                range: {
                  minValue: 0,
                  maxValue: 5,
                  message: translate("fiber_test_iloss_out_of_range_desc")
                }
              };
            }
            if (test.measurelength && test.callimitlength) {
              validationData["maxlength"] = {
                required: translate("formfield_error_general_required"),
                type: {
                  value: "decimal",
                  message: translate("should_be_atmost_two_place_decimal_digit")
                },
                range: {
                  minValue: 0,
                  maxValue: lengthMeasurementUnit == "feet" ? 131233.6 : 40000,
                  message:
                    lengthMeasurementUnit == "feet"
                      ? translate("fiber_test_maxlength_out_of_range_desc_feet")
                      : translate("fiber_test_maxlength_out_of_range_desc")
                }
              };
            }
          }
          break;
        case 3:
          validationData = {
            testmode: {
              required: translate("formfield_error_general_required")
            },
            direction: {
              required: translate("formfield_error_general_required")
            },
            referencemethod: {
              required: translate("formfield_error_general_required")
            },
            flux: {
              required: translate("formfield_error_general_required")
            },
            connectortype: {
              required: translate("formfield_error_general_required")
            }
          };
          break;
        case 4:
          if (findreplacetestnames) {
            validationData = {
              findName: {
                required: translate("formfield_error_general_required")
              }
            };
          }
          if (addchangeengineer) {
            validationData["engineerName"] = {
              required: translate("formfield_error_general_required")
            };
          }
          break;
        case 5:
          test.metadata.map(x => {
            if (x.enabled && x.value.trim() === "") {
              errors[x.level] = true;
            } else if (x.enabled && x.value.length > 12) {
              errors[x.level] = true;
            }
          });
          break;
        default:
          return true;
      }
    }

    if (
      (testHasResultWithMetaData && tabPosition === 2) ||
      (tabPosition === 5 &&
        currentTab === tabPosition &&
        test.metadatalookupid === CUSTOM_METADATA_STANDARD)
    ) {
    } else {
      errors = validateFormData(
        { ...test, engineerName, findName },
        validationData
      );
    }

    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();

      if (Number.isInteger(parseInt(missingFieldName))) {
        toast.error(
          ` ${this.props.translate("test_create_invalid_identifier")}`,
          {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true
          }
        );
      }
    }

    if (Object.keys(errors).length) {
      if (!currentTab && currentTab !== 0) {
        this.setState({ errors });
      } else {
        this.setState({ errors, tabPosition: currentTab });
      }
      return false;
    } else {
      this.setState({ errors });
      return true;
    }
  };

  editTest() {
    let isValidated = false;
    const {
      tabPosition,
      testHasResultWithMetaData,
      findreplacetestnames,
      addchangeengineer,
      nearfarconnector,
      findName,
      replaceName,
      engineerName
    } = this.state;
    for (let currentTab = 0; currentTab <= tabPosition; currentTab++) {
      isValidated = this.validate(currentTab);
      if (!isValidated) {
        return;
      }
    }
    if (isValidated) {
      let { test } = this.state;
      const { job, pager, lengthMeasurementUnit, userPreference } = this.props;

      if (!this.validate()) {
        return;
      }

      //Remove Disabled Metadata
      if (
        testHasResultWithMetaData ||
        test.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) {
        let metadata = [...test.metadata];
        metadata.map(e => {
          if (!e.enabled) {
            e.field = "";
            e.value = "";
            return e;
          }
        });
        test.metadata = metadata;
      }
      let editDetails = {
        replace: findreplacetestnames,
        findName: findName,
        replacename: replaceName,
        addChangeConnectorManufacture: nearfarconnector,
        overrideCableShielding: false,
        cableShielding: test.cableshielding,
        connectorBrandNearName: test.connectorbrandnear,
        connectorBrandNFarName: test.connectorbrandfar,
        addChangeengineer: addchangeengineer,
        engineerName: engineerName
      };
      this.setState(
        {
          editSaving: true
        },
        () => {
          test.maxlength =
            lengthMeasurementUnit == "feet"
              ? Math.round(test.maxlength * 0.3048 * 100) / 100
              : test.maxlength;
          this.props.saveEditTest({ ...test, editDetails }, pager, "fiber");
        }
      );
    }
  }

  render() {
    const {
      classes,
      translate,
      job,
      lengthMeasurementUnit,
      testNames
    } = this.props;

    let { custom, standards, fiberStandards, error, multiple, selectedTests } = this.props;

    let metadataOption;
    let {
      test,
      errors,
      tabs,
      testPrefixType,
      tabPosition,
      disabledToogleIdentifier,
      allowApplyLength,
      allowEditMaxLength,
      boolValue,
      lossBudget,
      fiberappgroups,
      cablebrands,
      fiberstdgroups,
      testmode,
      direction,
      testcordreference,
      connectortype,
      wavelengths,
      wavelengthdetails,
      cordtypes,
      cabletypes,
      cableparts,
      stdDetails,
      appDetails,
      disbleBudgetLossMin,
      disbleBudgetLossMax,
      disableRefractiveIndex,
      hasResult,
      testHasResultWithMetaData,
      findreplacetestnames,
      addchangeengineer,
      nearfarconnector,
      findName,
      replaceName,
      engineerName,
      modalRef,
      multiCordTypes
    } = this.state;

    if (!custom) return null;

    const isTRCVerify = multiple ? selectedTests.some(t => t.trcverify === 1) : test.trcverify === 1;

    custom = custom.sort((a, b) => b.level > a.level);
    let showAllMetadataSwitch = this.state.test.metadata
      ? this.state.test.metadata.filter(n => n.value).length !== 6
      : null;

    function testCordTypeField(onChange) {
      let selectedGroup = (test.group)? test.group.name : "";
      if (selectedGroup != "ANSI/TIA") selectedGroup = "other";
      let selectedCType = test.cabletype.name; 
      if(selectedCType.startsWith("OM")) selectedCType = "MM";
      if(selectedCType.startsWith("OS")) selectedCType = "SM";
      let options = cordtypes;
      console.log("PSOUT - %s,%s",selectedGroup, selectedCType);
      if (
        test.limitmethodtype &&
        test.cabletype &&
        test.limitmethodtype.name == "Cabling Standards" &&
        multiCordTypes
      ) {
        const matchedType = multiCordTypes.find(
          x => x.group === selectedGroup && x.cabletype === selectedCType
        );       
        options = matchedType ? matchedType.refCordLoss : [];
      }             
      return (
          <FormControl
            fullWidth
            margin="normal"
            required
            error={errors.cordlosstype ? true : false}
          >
            <InputLabel htmlFor="cordlosstype">
              {translate("test_cord_type")}
            </InputLabel>
            <Select
              value={
                test.cordlosstype ? test.cordlosstype.id : ""
              }
              onChange={e => onChange(e, true)}
              input={
                <Input
                  name="cordlosstype"
                  id="cordlosstype"
                  value={
                    test.cordlosstype ? test.cordlosstype.id : ""
                  }
                  fullWidth
                />
              }
            >
              {options
                ? options.map((cord, index) => {
                    return (
                      <MenuItem key={index} value={cord.id}>
                        {cord.name}
                      </MenuItem>
                    );
                  })
                : null}
            </Select>
            <FormHelperText>
              {errors.cordlosstype
                ? errors.cordlosstype
                : translate("test_cord_type")}
            </FormHelperText>
          </FormControl>
        )
    }
    
    return (
      <Modal open={this.state.open} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("test_edit_title")}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>

            <ModalContents>
              {error && error === "error_duplicatetest" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("test_duplicate_error")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_duplicate_error_desc")}
                  </Typography>
                </Paper>
              )}
              {error && error === "error_testnamesize_exceeds_80chars" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_length")}
                  </Typography>
                </Paper>
              )}

              {error && error === "tests_name_couldn't_be_replaced" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("testlist_couldnot_be_updated", {
                      tests: testNames.join(", ")
                    })}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_name_couldnot_be_blanck")}
                  </Typography>
                </Paper>
              )}

              <form noValidate autoComplete="off" className={classes.form} ref={modalRef}>
                <Tabs value={tabPosition} onChange={this.handleTabChange}>
                  {tabs.map((tab, index) => {
                    return <Tab key={index} label={tab} />;
                  })}
                </Tabs>
                {(!hasResult
                  ? tabPosition === 0 && !multiple
                  : testHasResultWithMetaData
                  ? tabPosition === 0 && !multiple && testHasResultWithMetaData
                  : tabPosition === 0 && !multiple) && (
                  <div className={classes.summary}>
                    <TextField
                      error={errors.name ? true : false}
                      required
                      name="name"
                      label={translate("test_name")}
                      margin="normal"
                      fullWidth
                      value={test.name ? test.name : ""}
                      onChange={this.onChange}
                      inputProps={{
                        maxlength: 76
                      }}
                      InputProps={{
                        readOnly: isTRCVerify,
                      }}
                      helperText={
                        errors.name ? errors.name : translate("test_name_help")
                      }
                    />
                  </div>
                )}
                {!testHasResultWithMetaData &&
                  !hasResult &&
                  (!multiple && tabPosition === 1) && (
                    <div className={classes.summary}>
                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required
                        error={errors.cablebrand ? true : false}
                      >
                        <InputLabel htmlFor="cablebrand">
                          {translate("cable_brand")}
                        </InputLabel>
                        <Select
                          value={test.cablebrand ? test.cablebrand.id : ""}
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="cablebrand"
                              id="cablebrand"
                              value={test.cablebrand ? test.cablebrand.id : ""}
                            />
                          }
                          fullWidth
                        >
                          {cablebrands
                            ? cablebrands.map((cablebrand, index) => {
                                return (
                                  <MenuItem key={index} value={cablebrand.id}>
                                    {cablebrand.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.cablebrand
                            ? errors.cablebrand
                            : translate("cable_brand")}
                        </FormHelperText>
                      </FormControl>

                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required
                        error={errors.cabletype ? true : false}
                      >
                        <InputLabel htmlFor="cabletype">
                          {translate("test_cable_type")}
                        </InputLabel>
                        <Select
                          value={test.cabletype ? test.cabletype.id : ""}
                          onChange={e => this.onChange(e, true, cabletypes)}
                          input={
                            <Input
                              name="cabletype"
                              id="cabletype"
                              value={test.cabletype ? test.cabletype.id : ""}
                            />
                          }
                          fullWidth
                        >
                          {cabletypes
                            ? cabletypes.map((standard, index) => {
                                return (
                                  <MenuItem key={index} value={standard.id}>
                                    {standard.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.cabletype
                            ? errors.cabletype
                            : translate("test_cable_type")}
                        </FormHelperText>
                      </FormControl>

                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required
                        error={errors.cablepart ? true : false}
                      >
                        <InputLabel htmlFor="cablepart">
                          {translate("test_cable_part_number")}
                        </InputLabel>
                        <Select
                          value={test.cablepart ? test.cablepart.id : ""}
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="cablepart"
                              id="cablepart"
                              value={test.cablepart ? test.cablepart.id : ""}
                            />
                          }
                          fullWidth
                        >
                          {cableparts
                            ? cableparts.map((cabletype, index) => {
                                return (
                                  <MenuItem key={index} value={cabletype.id}>
                                    {cabletype.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.cablepart
                            ? errors.cablepart
                            : translate("test_cable_part_number")}
                        </FormHelperText>
                      </FormControl>
                      <TextField
                        error={errors.refractiveindex}
                        required
                        name="refractiveindex"
                        label={translate("test_refractive_index")}
                        margin="normal"
                        fullWidth
                        value={test.refractiveindex}
                        disabled={disableRefractiveIndex}
                        onChange={this.onChange}
                        helperText={
                          errors.refractiveindex
                            ? errors.refractiveindex
                            : translate("test_refractive_index")
                        }
                      />

                      <FormControl
                        margin="normal"
                        fullWidth
                        required
                        error={errors.limitmethodtype ? true : false}
                      >
                        <InputLabel htmlFor="limitmethodtype">
                          {translate("test_loss_budget")}
                        </InputLabel>
                        <Select
                          value={
                            test.limitmethodtype ? test.limitmethodtype.id : ""
                          }
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="limitmethodtype"
                              id="limitmethodtype"
                              value={
                                test.limitmethodtype
                                  ? test.limitmethodtype.id
                                  : ""
                              }
                              fullWidth
                            />
                          }
                        >
                          {lossBudget
                            ? lossBudget.map((lossbudget, index) => {
                                return (
                                  <MenuItem key={index} value={lossbudget.id}>
                                    {lossbudget.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.limitmethodtype
                            ? errors.limitmethodtype
                            : translate("test_loss_budget")}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  )}
                {/* {tabPosition === 2 && test.limitmethodtype
                && (test.limitmethodtype.name === 'Cabling Standards' || test.limitmethodtype)
                } */}

                {/* Budget Loss Standard */}
                {!testHasResultWithMetaData &&
                  (multiple ? tabPosition === 1 : tabPosition === 2) &&
                  test.limitmethodtype &&
                  test.limitmethodtype.name === "Cabling Standards" && (
                    <div className={classes.summary}>
                      <FormControl
                        margin="normal"
                        fullWidth
                        required
                        error={errors.group ? true : false}
                      >
                        <InputLabel htmlFor="group">
                          {translate("test_group")}
                        </InputLabel>
                        <Select
                          value={test.group ? test.group.id : ""}
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="group"
                              id="group"
                              value={test.group ? test.group.id : ""}
                              fullWidth
                            />
                          }
                        >
                          {fiberstdgroups
                            ? fiberstdgroups.map((fiberstd, index) => {
                                return (
                                  <MenuItem key={index} value={fiberstd.id}>
                                    {fiberstd.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.group
                            ? errors.group
                            : translate("test_group")}
                        </FormHelperText>
                      </FormControl>
                      <FormControl
                        margin="normal"
                        fullWidth
                        required
                        error={errors.standard ? true : false}
                      >
                        <InputLabel htmlFor="standard">
                          {translate("test_standards")}
                        </InputLabel>
                        <Select
                          value={test.standard ? test.standard.id : ""}
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="standard"
                              id="standard"
                              value={test.standard ? test.standard.id : ""}
                              fullWidth
                            />
                          }
                        >
                          {stdDetails
                            ? stdDetails.map((stdDetail, index) => {
                                return (
                                  <MenuItem key={index} value={stdDetail.id}>
                                    {stdDetail.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.standard
                            ? errors.standard
                            : translate("test_standards")}
                        </FormHelperText>
                      </FormControl>
                      {testCordTypeField(this.onChange)}                      
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={errors.adapterscount}
                            required
                            name="adapterscount"
                            label={translate("test_no_of_adapters")}
                            margin="normal"
                            fullWidth
                            value={test.adapterscount}
                            onChange={this.onChange}
                            helperText={
                              errors.adapterscount
                                ? errors.adapterscount
                                : translate("test_no_of_adapters")
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={errors.splicecount}
                            required
                            name="splicecount"
                            label={translate("test_no_of_splices")}
                            margin="normal"
                            fullWidth
                            value={test.splicecount}
                            onChange={this.onChange}
                            helperText={
                              errors.splicecount
                                ? errors.splicecount
                                : translate("test_no_of_splices")
                            }
                          />
                        </Grid>
                      </Grid>

                      <TextField
                        error={errors.maxlength}
                        required
                        name="maxlength"
                        label={
                          lengthMeasurementUnit != "feet"
                            ? translate("test_max_length")
                            : translate("test_max_length_feet")
                        }
                        margin="normal"
                        fullWidth
                        value={test.maxlength}
                        onChange={this.onChange}
                        helperText={
                          errors.maxlength
                            ? errors.maxlength
                            : lengthMeasurementUnit != "feet"
                            ? translate("test_max_length")
                            : translate("test_max_length_feet")
                        }
                        disabled
                      />
                    </div>
                  )}
                {/* Budget Loss Application */}
                {!testHasResultWithMetaData &&
                  (multiple ? tabPosition === 1 : tabPosition === 2) &&
                  test.limitmethodtype &&
                  test.limitmethodtype.name === "Applications" && (
                    <div className={classes.summary}>
                      <FormControl
                        margin="normal"
                        fullWidth
                        required
                        error={errors.group ? true : false}
                      >
                        <InputLabel htmlFor="group">
                          {translate("test_group")}
                        </InputLabel>
                        <Select
                          value={test.group ? test.group.id : ""}
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="group"
                              id="group"
                              value={test.group ? test.group.id : ""}
                              fullWidth
                            />
                          }
                        >
                          {fiberappgroups
                            ? fiberappgroups.map((fiberappgroup, index) => {
                                return (
                                  <MenuItem
                                    key={index}
                                    value={fiberappgroup.id}
                                  >
                                    {fiberappgroup.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.group
                            ? errors.group
                            : translate("test_group")}
                        </FormHelperText>
                      </FormControl>
                      <FormControl
                        margin="normal"
                        fullWidth
                        required
                        error={errors.application ? true : false}
                      >
                        <InputLabel htmlFor="application">
                          {translate("test_application")}
                        </InputLabel>
                        <Select
                          value={test.application ? test.application.id : ""}
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="application"
                              id="application"
                              value={
                                test.application ? test.application.id : ""
                              }
                              fullWidth
                            />
                          }
                        >
                          {appDetails
                            ? appDetails.map((appDetail, index) => {
                                return (
                                  <MenuItem key={index} value={appDetail.id}>
                                    {appDetail.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.application
                            ? errors.application
                            : translate("test_application")}
                        </FormHelperText>
                      </FormControl>
                      <Grid container>
                        <Grid item xs={12} sm={12} className={classes.addField}>
                          <span>
                            {translate("test_loss_budget")} ({translate("dB")})
                            *
                          </span>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.halfField}>
                            <p>{this.budgetLossMin}:</p>
                            <TextField
                              error={errors.illosswllow}
                              required
                              name="illosswllow"
                              label=""
                              margin="normal"
                              fullWidth
                              value={test.illosswllow}
                              onChange={this.onChange}
                              disabled
                              helperText={
                                errors.illosswllow ? errors.illosswllow : ""
                              }
                            />
                          </div>
                          <div className={classes.halfField}>
                            <p>{this.budgetLossMax}:</p>
                            <TextField
                              error={errors.illosswlhigh}
                              required
                              name="illosswlhigh"
                              label=""
                              margin="normal"
                              fullWidth
                              value={test.illosswlhigh}
                              onChange={this.onChange}
                              disabled
                              helperText={
                                errors.illosswlhigh ? errors.illosswlhigh : ""
                              }
                            />
                          </div>
                        </Grid>
                      </Grid>
                      <TextField
                        error={errors.maxlength}
                        required
                        name="maxlength"
                        label={
                          lengthMeasurementUnit != "feet"
                            ? translate("test_max_length")
                            : translate("test_max_length_feet")
                        }
                        margin="normal"
                        fullWidth
                        value={test.maxlength}
                        onChange={this.onChange}
                        helperText={
                          errors.maxlength
                            ? errors.maxlength
                            : lengthMeasurementUnit != "feet"
                            ? translate("test_max_length")
                            : translate("test_max_length_feet")
                        }
                        disabled
                      />
                    </div>
                  )}
                {/* Budget Loss MANUAL*/}
                {!testHasResultWithMetaData &&
                  (multiple ? tabPosition === 1 : tabPosition === 2) &&
                  test.limitmethodtype &&
                  test.limitmethodtype.name === "Manual Loss Budget" && (
                    <div className={classes.summary}>
                      <FormControl
                        margin="normal"
                        fullWidth
                        required
                        error={errors.limitwavelength ? true : false}
                      >
                        <InputLabel htmlFor="limitwavelength">
                          {translate("test_wave_length")}
                        </InputLabel>
                        <Select
                          value={
                            test.limitwavelength ? test.limitwavelength.id : ""
                          }
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="limitwavelength"
                              id="limitwavelength"
                              value={
                                test.limitwavelength
                                  ? test.limitwavelength.id
                                  : ""
                              }
                              fullWidth
                            />
                          }
                        >
                          {wavelengths
                            ? wavelengths.map((wl, index) => {
                                return (
                                  <MenuItem key={index} value={wl.id}>
                                    {wl.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.limitwavelength
                            ? errors.limitwavelength
                            : translate("test_wave_length")}
                        </FormHelperText>
                      </FormControl>
                      <Grid container>
                        <Grid item xs={12} sm={12} className={classes.addField}>
                          <span>
                            {translate("test_loss_budget")} ({translate("dB")})
                            *
                          </span>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.halfField}>
                            <p>{this.budgetLossMin}:</p>
                            <TextField
                              error={errors.illosswllow}
                              required
                              name="illosswllow"
                              label=""
                              margin="normal"
                              fullWidth
                              value={test.illosswllow}
                              onChange={this.onChange}
                              helperText={
                                errors.illosswllow ? errors.illosswllow : ""
                              }
                              disabled={disbleBudgetLossMin}
                            />
                          </div>
                          <div className={classes.halfField}>
                            <p>{this.budgetLossMax}:</p>
                            <TextField
                              error={errors.illosswlhigh}
                              required
                              name="illosswlhigh"
                              label=""
                              margin="normal"
                              fullWidth
                              value={test.illosswlhigh}
                              onChange={this.onChange}
                              helperText={
                                errors.illosswlhigh ? errors.illosswlhigh : ""
                              }
                              disabled={disbleBudgetLossMax}
                            />
                          </div>
                        </Grid>
                      </Grid>
                      {/* Length */}
                      <Grid container>
                        <Grid item xs={12} sm={12} className={classes.addField}>
                          <span>{translate("test_length")}</span>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={test.measurelength}
                                onChange={this.onLenghtLimitChange}
                                value={test.measurelength}
                                name={"measurelength"}
                              />
                            }
                            label={translate("use_length_from_the_results")}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={test.callimitlength}
                                onChange={this.onLenghtLimitChange}
                                value={test.callimitlength}
                                name={"callimitlength"}
                              />
                            }
                            label={translate(
                              "apply_length_limit_to_the_test_results"
                            )}
                            disabled={allowApplyLength}
                          />
                        </Grid>
                      </Grid>

                      <TextField
                        error={errors.maxlength}
                        required
                        name="maxlength"
                        label={
                          lengthMeasurementUnit != "feet"
                            ? translate("test_length_limit")
                            : translate("test_length_limit_feet")
                        }
                        margin="normal"
                        fullWidth
                        value={test.maxlength}
                        onChange={this.onChange}
                        helperText={
                          errors.maxlength
                            ? errors.maxlength
                            : lengthMeasurementUnit != "feet"
                            ? translate("test_length_limit")
                            : translate("test_length_limit_feet")
                        }
                        disabled={allowEditMaxLength}
                      />
                    </div>
                  )}

                {/* Budget Loss calculator */}
                {!testHasResultWithMetaData &&
                  (multiple ? tabPosition === 1 : tabPosition === 2) &&
                  test.limitmethodtype &&
                  test.limitmethodtype.name === "Loss Budget Calculator" && (
                    <div className={classes.summary}>
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            fullWidth
                            margin="normal"
                            required
                            error={errors.limitwavelength ? true : false}
                          >
                            <InputLabel htmlFor="limitwavelength">
                              {translate("test_wave_length")}
                            </InputLabel>
                            <Select
                              value={
                                test.limitwavelength
                                  ? test.limitwavelength.id
                                  : ""
                              }
                              onChange={e => this.onChange(e, true)}
                              input={
                                <Input
                                  name="limitwavelength"
                                  id="limitwavelength"
                                  value={
                                    test.limitwavelength
                                      ? test.limitwavelength.id
                                      : ""
                                  }
                                  fullWidth
                                />
                              }
                            >
                              {wavelengths
                                ? wavelengths.map((wl, index) => {
                                    return (
                                      <MenuItem key={index} value={wl.id}>
                                        {wl.name}
                                      </MenuItem>
                                    );
                                  })
                                : null}
                            </Select>
                            <FormHelperText>
                              {errors.limitwavelength
                                ? errors.limitwavelength
                                : translate("test_wave_length")}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          {testCordTypeField(this.onChange)}
                        </Grid>
                      </Grid>

                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            component="fieldset"
                            required
                            className={classes.formControl}
                            error={errors.cableshielding ? true : false}
                          >
                            <FormLabel component="legend">
                              {translate("test_length")}
                            </FormLabel>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={test.measurelength}
                                  onChange={this.onLenghtLimitChange}
                                  value={test.measurelength}
                                  name={"measurelength"}
                                />
                              }
                              label={translate("use_length_from_the_results")}
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={test.callimitlength}
                                  onChange={this.onLenghtLimitChange}
                                  value={test.callimitlength}
                                  name={"callimitlength"}
                                />
                              }
                              label={translate(
                                "apply_length_limit_to_the_test_results"
                              )}
                              disabled={allowApplyLength}
                            />
                            <TextField
                              error={errors.maxlength}
                              required
                              name="maxlength"
                              label={
                                lengthMeasurementUnit != "feet"
                                  ? translate("test_length_limit")
                                  : translate("test_length_limit_feet")
                              }
                              margin="normal"
                              fullWidth
                              value={test.maxlength}
                              onChange={this.onChange}
                              disabled={allowEditMaxLength}
                              helperText={
                                errors.maxlength
                                  ? errors.maxlength
                                  : lengthMeasurementUnit != "feet"
                                  ? translate("test_length_limit")
                                  : translate("test_length_limit_feet")
                              }
                            />
                          </FormControl>
                          <Grid container>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              className={classes.addField}
                            >
                              <span>
                                {translate("test_loss_budget")}{" "}
                                {translate("loss_budget_unit")} *
                              </span>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                              <div className={classes.halfField}>
                                <p>{this.budgetLossMin}:</p>
                                <TextField
                                  error={errors.illosswllow}
                                  required
                                  name="illosswllow"
                                  label=""
                                  margin="normal"
                                  fullWidth
                                  value={test.illosswllow}
                                  onChange={this.onChange}
                                  helperText={
                                    errors.illosswllow ? errors.illosswllow : ""
                                  }
                                  disabled={disbleBudgetLossMin}
                                />
                              </div>
                              <div className={classes.halfField}>
                                <p>{this.budgetLossMax}:</p>
                                <TextField
                                  error={errors.illosswlhigh}
                                  required
                                  name="illosswlhigh"
                                  label=""
                                  margin="normal"
                                  fullWidth
                                  value={test.illosswlhigh}
                                  onChange={this.onChange}
                                  helperText={
                                    errors.illosswlhigh
                                      ? errors.illosswlhigh
                                      : ""
                                  }
                                  disabled={disbleBudgetLossMax}
                                />
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={errors.splicecount}
                            required
                            name="splicecount"
                            label={translate("test_no_of_splices")}
                            margin="normal"
                            fullWidth
                            value={test.splicecount}
                            onChange={this.onChange}
                            helperText={
                              errors.splicecount
                                ? errors.splicecount
                                : translate("test_no_of_splices")
                            }
                          />
                          <TextField
                            error={errors.spliceloss}
                            required
                            name="spliceloss"
                            label={translate("test_splice_loss_value")}
                            margin="normal"
                            fullWidth
                            value={test.spliceloss}
                            onChange={this.onChange}
                            helperText={
                              errors.spliceloss
                                ? errors.spliceloss
                                : translate("test_splice_loss_value")
                            }
                          />
                          <TextField
                            error={errors.adapterscount}
                            required
                            name="adapterscount"
                            label={translate("test_no_of_adapters")}
                            margin="normal"
                            fullWidth
                            value={test.adapterscount}
                            onChange={this.onChange}
                            helperText={
                              errors.adapterscount
                                ? errors.adapterscount
                                : translate("test_no_of_adapters")
                            }
                          />
                          <TextField
                            error={errors.adapterloss}
                            required
                            name="adapterloss"
                            label={translate("test_adapter_loss_value")}
                            margin="normal"
                            fullWidth
                            value={test.adapterloss}
                            onChange={this.onChange}
                            helperText={
                              errors.adapterloss
                                ? errors.adapterloss
                                : translate("test_adapter_loss_value")
                            }
                          />
                        </Grid>
                      </Grid>
                    </div>
                  )}

                {!testHasResultWithMetaData &&
                  (multiple ? tabPosition === 2 : tabPosition === 3) && (
                    <div className={classes.summary}>
                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required
                        error={errors.testmode ? true : false}
                      >
                        <InputLabel htmlFor="testmode">
                          {translate("test_mode")}
                        </InputLabel>
                        <Select
                          value={test.testmode ? test.testmode.id : ""}
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="testmode"
                              id="testmode"
                              value={test.testmode ? test.testmode.id : ""}
                            />
                          }
                          fullWidth
                        >
                          {testmode
                            ? testmode.map((mode, index) => {
                                return (
                                  <MenuItem key={index} value={mode.id}>
                                    {mode.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.testmode
                            ? errors.testmode
                            : translate("test_mode")}
                        </FormHelperText>
                      </FormControl>
                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required
                        error={errors.direction ? true : false}
                      >
                        <InputLabel htmlFor="direction">
                          {translate("test_direction")}
                        </InputLabel>
                        <Select
                          value={test.direction ? test.direction.id : ""}
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="direction"
                              id="direction"
                              value={test.direction ? test.direction.id : ""}
                            />
                          }
                          fullWidth
                        >
                          {direction
                            ? direction.map((dir, index) => {
                                return (
                                  <MenuItem key={index} value={dir.id}>
                                    {dir.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.direction
                            ? errors.direction
                            : translate("test_direction")}
                        </FormHelperText>
                      </FormControl>
                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required
                        error={errors.referencemethod ? true : false}
                      >
                        <InputLabel htmlFor="referencemethod">
                          {translate("test_cord_reference")}
                        </InputLabel>
                        <Select
                          value={
                            test.referencemethod ? test.referencemethod.id : ""
                          }
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="referencemethod"
                              id="referencemethod"
                              value={
                                test.referencemethod
                                  ? test.referencemethod.id
                                  : ""
                              }
                            />
                          }
                          fullWidth
                        >
                          {testcordreference
                            ? testcordreference.map((cord, index) => {
                                return (
                                  <MenuItem key={index} value={cord.id}>
                                    {cord.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.referencemethod
                            ? errors.referencemethod
                            : translate("test_cord_reference")}
                        </FormHelperText>
                      </FormControl>

                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required={this.cableType !== "SM"}
                        error={errors.flux ? true : false}
                      >
                        <InputLabel htmlFor="flux">
                          {translate("test_encircled_flux")}
                        </InputLabel>
                        <Select
                          disabled={this.cableType === "SM"}
                          value={test.flux || false}
                          onChange={e => this.onChange(e)}
                          input={
                            <Input name="flux" id="flux" value={test.flux} />
                          }
                          fullWidth
                        >
                          {boolValue.map((bool, index) => {
                            return (
                              <MenuItem key={index} value={bool.id}>
                                {bool.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        <FormHelperText>
                          {errors.flux
                            ? errors.flux
                            : translate("test_encircled_flux")}
                        </FormHelperText>
                      </FormControl>
                      <FormControl
                        className={classes.textField}
                        margin="normal"
                        required
                        error={errors.connectortype ? true : false}
                      >
                        <InputLabel htmlFor="connectortype">
                          {translate("test_connector_type")}
                        </InputLabel>
                        <Select
                          value={
                            test.connectortype ? test.connectortype.id : ""
                          }
                          onChange={e => this.onChange(e, true)}
                          input={
                            <Input
                              name="connectortype"
                              id="connectortype"
                              value={
                                test.connectortype ? test.connectortype.id : ""
                              }
                            />
                          }
                          fullWidth
                        >
                          {connectortype
                            ? connectortype.map((connector, index) => {
                                return (
                                  <MenuItem key={index} value={connector.id}>
                                    {connector.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </Select>
                        <FormHelperText>
                          {errors.connectortype
                            ? errors.connectortype
                            : translate("test_connector_type")}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  )}

                {((testHasResultWithMetaData && tabPosition === 1) ||
                  (multiple ? tabPosition === 0 : tabPosition === 4) ||
                  (hasResult &&
                    (!multiple && tabPosition === 1))) && (
                  <div className={classes.summary}>
                    <Typography type="subheading">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="findreplacetestnames"
                            checked={findreplacetestnames}
                            onChange={this.editTestDetails}
                            disabled={isTRCVerify}
                          />
                        }
                        label={
                          isTRCVerify ?
                          <Typography style={{ color: "#dddddd" }}>
                            {" "}
                            <b>{translate("find_and_replace_test_name")}</b>
                          </Typography> :
                          <b>{translate("find_and_replace_test_name")}</b>
                        }
                      />
                    </Typography>
                    {findreplacetestnames ? (
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={errors.findName ? true : false}
                            name="findName"
                            label={translate("test_name_find")}
                            margin="normal"
                            fullWidth
                            value={findName}
                            onChange={this.editTestDetails}
                            helperText={
                              errors.findName
                                ? errors.findName
                                : translate("test_name_find_helper")
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={errors.replaceName ? true : false}
                            label={translate("test_name_replace")}
                            name="replaceName"
                            margin="normal"
                            fullWidth
                            value={replaceName}
                            onChange={this.editTestDetails}
                            inputProps={{
                              maxlength: 80
                            }}
                            helperText={
                              errors.replaceName
                                ? errors.replaceName
                                : translate("test_name_replace_helper")
                            }
                          />
                        </Grid>
                      </Grid>
                    ) : null}
                    <Typography type="subheading">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="addchangeengineer"
                            checked={addchangeengineer}
                            onChange={this.editTestDetails}
                            disabled={!hasResult}
                          />
                        }
                        label={
                          !hasResult ? (
                            <Typography style={{ color: "#dddddd" }}>
                              {" "}
                              <b>{translate("add_or_change_engineer")}</b>
                            </Typography>
                          ) : (
                            <b>{translate("add_or_change_engineer")}</b>
                          )
                        }
                      />
                    </Typography>
                    {addchangeengineer ? (
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={errors.engineerName ? true : false}
                            name="engineerName"
                            label={translate("test_engineer_name")}
                            margin="normal"
                            fullWidth
                            value={engineerName}
                            onChange={this.editTestDetails}
                            helperText={
                              errors.engineerName
                                ? errors.engineerName
                                : translate("test_engineer_name_helper")
                            }
                          />
                        </Grid>
                      </Grid>
                    ) : null}
                    <Typography type="subheading">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="nearfarconnector"
                            checked={nearfarconnector}
                            onChange={this.editTestDetails}
                            disabled={true}
                          />
                        }
                        label={
                          <Typography style={{ color: "#dddddd" }}>
                            {" "}
                            <b>{translate("update_near_far_end_connector")}</b>
                          </Typography>
                        }
                      />
                    </Typography>
                    {nearfarconnector ? (
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            fullWidth
                            margin="normal"
                            error={errors.connectorbrandnear ? true : false}
                          >
                            <InputLabel htmlFor="connectorbrandnear">
                              {translate("test_connector_brand_near")}
                            </InputLabel>
                            <Select
                              value={test.connectorbrandnear}
                              onChange={this.onChange}
                              input={
                                <Input
                                  name="connectorbrandnear"
                                  id="connectorbrandnear"
                                  value={test.connectorbrandnear}
                                  fullWidth
                                />
                              }
                            ></Select>
                            <FormHelperText>
                              {errors.connectorbrandnear
                                ? errors.connectorbrandnear
                                : translate("test_connector_brand_near")}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            margin="normal"
                            fullWidth
                            error={errors.connectorbrandfar ? true : false}
                          >
                            <InputLabel htmlFor="connectorbrandfar">
                              {translate("test_connector_brand_far_helper")}
                            </InputLabel>
                            <Select
                              value={test.connectorbrandfar}
                              onChange={this.onChange}
                              input={
                                <Input
                                  name="connectorbrandfar"
                                  id="connectorbrandfar"
                                  value={test.connectorbrandfar}
                                  fullWidth
                                />
                              }
                            ></Select>
                            <FormHelperText>
                              {errors.connectorbrandfar
                                ? errors.connectorbrandfar
                                : translate("test_connector_brand_far_helper")}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                      </Grid>
                    ) : null}
                  </div>
                )}

                {((testHasResultWithMetaData && tabPosition === 2) ||
                  (multiple ? tabPosition === 4 : tabPosition === 5)) && (
                  <div className={classes.summary}>
                    {showAllMetadataSwitch && (
                      <Typography type="subheading">
                        <FormControlLabel
                          control={
                            <Switch
                              name="allmetadataoptions"
                              checked={test.allmetadataoptions}
                              onChange={(e, checked) =>
                                this.onToggleChange(e, checked)
                              }
                              disabled={disabledToogleIdentifier}
                            />
                          }
                          label={translate("test_add_metadata_item")}
                        />
                      </Typography>
                    )}

                    {custom &&
                      custom
                        .sort((a, b) => {
                          return a.level > b.level
                            ? -1
                            : a.level < b.level
                            ? 1
                            : 0;
                        })
                        .map((c, index) => {
                          metadataOption = test.metadata
                            ? test.metadata.find(
                                x =>
                                  parseInt(x.level, 10) ===
                                  parseInt(c.level, 10)
                              )
                            : null;
                          return metadataOption &&
                            (test.allmetadataoptions ||
                              metadataOption.default ||
                              metadataOption.enabled) &&
                            c.level !== 1 ? (
                            <div key={index}>
                              <Checkbox
                                name={c.level}
                                checked={metadataOption.enabled}
                                onChange={this.onCustomCheckChange}
                              />
                              <select
                                name={c.level}
                                value={metadataOption.field}
                                onChange={this.onCustomChange}
                                disabled={!metadataOption.enabled}
                              >
                                {c.values.map((o, index) => {
                                  return (
                                    <option key={index} value={o.id}>
                                      {o.name}
                                    </option>
                                  );
                                })}
                              </select>
                              <TextField
                                error={errors[c.level] ? true : false}
                                required
                                name={c.level}
                                margin="normal"
                                value={metadataOption.value}
                                onChange={this.onChangeMetadataField}
                                disabled={!metadataOption.enabled}
                              />
                            </div>
                          ) : null;
                        })}
                  </div>
                )}
              </form>
            </ModalContents>

            <ModalFooter>
              <Button
                raised
                className={classes.button}
                onClick={() => this.tabBack()}
                disabled={!this.canTabBack().can ? true : false}
              >
                <Icon>navigate_before</Icon>
              </Button>

              <Button
                raised
                className={classes.button}
                onClick={() => this.tabNext()}
                disabled={!this.canTabNext().can ? true : false}
              >
                <Icon>navigate_next</Icon>
              </Button>

              {this.tabsComplete() ? (
                <Button
                  raised
                  color="accent"
                  className={classes.submit}
                  onClick={() => this.editTest()}
                  type="submit"
                >
                  {translate("test_edit")}
                </Button>
              ) : null}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    );
  }

  componentDidMount() {
    const { job, test, translate, multiple, selectedTests } = this.props;
    const disabledToogleIdentifier = this.state.test.metadata
      .filter(identifier => identifier.level !== "1")
      .every(identifier => identifier.default === true);
    let { tabs } = this.state;
    if (multiple) {
      tabs.shift();
    }

    this.setState({
      disabledToogleIdentifier,
      tabs
    });
    if (
      selectedTests &&
      selectedTests.length &&
      test &&
      test.id == selectedTests[0].id
    ) {
      this.setState({
        isConvertedToFeet: true
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { translate, job, multiple, userPreference } = this.props;
    const { test, otherTest, selectedTests } = nextProps;
    let { editSaving, tabs, hasResult, testHasResultWithMetaData } = this.state;
    
    if (test && otherTest) {
      if (otherTest.devicetype && !hasResult && !multiple) {
        hasResult = true;
        if (!multiple) {
          tabs = [translate("test_details"), translate("test_edit_details")];
        } else {
          tabs = [translate("test_edit_details")];
        }
        if (
          (otherTest.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) &&
          !multiple 
        ) {
          testHasResultWithMetaData = true;
          tabs.push(translate("test_metadata"));
        }
      }

      if (!otherTest.devicetype && !multiple) {
        tabs =
          test.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)
            ? [
                translate("test_details"),
                translate("fiber_test_cable_type"),
                translate("test_budget_loss"),
                translate("test_settings"),
                translate("test_edit_details"),
                translate("test_metadata")
              ]
            : [
                translate("test_details"),
                translate("fiber_test_cable_type"),
                translate("test_budget_loss"),
                translate("test_settings"),
                translate("test_edit_details")
              ];
      }
    } else {
      tabs = [translate("test_edit_details")];
    }
    if (test && !editSaving) {
      if (test && test.Technician) {
        this.setState({ engineerName: test.Technician });
      }
      if (test.metadata) {
        let metadata = [...test.metadata];
        let curStateMetaData = [...this.state.test.metadata];
        metadata.forEach(e => {
          curStateMetaData.forEach(ce => {
            if (ce.level === e.level) {
              ce.field = e.field;
              ce.value = e.value;
              e.value ? (ce.enabled = true) : (ce.enabled = false);
            }
          });
        });
        test.metadata = curStateMetaData;
      }
      const testCheck = selectedTests.filter(tst => tst.id == test.id);
      if (selectedTests && selectedTests.length && test && testCheck.length) {
        this.setFiberStandards(
          { ...test },
          hasResult,
          tabs,
          testHasResultWithMetaData
        );
      }
    }
  }

  setFiberStandards = (test, hasResult, tabs, testHasResultWithMetaData) => {
    const { standards, fiberStandards, lengthMeasurementUnit } = this.props;
    if (!fiberStandards) {
      return;
    }

    let lossBudget,
      fiberappgroups,
      cablebrands,
      fiberstdgroups,
      testmode,
      direction,
      testcordreference,
      connectortype,
      wavelengthdetails,
      cordtypes,
      disbleBudgetLossMin,
      disbleBudgetLossMax,
      allowApplyLength,
      allowEditMaxLength,
      disableRefractiveIndex,
      multiCordTypes;

    if (fiberStandards) {
      fiberappgroups = fiberStandards.appgroups;
      cablebrands = fiberStandards.cablebrands;
      fiberstdgroups = fiberStandards.stdgroups;
      lossBudget = fiberStandards.lossbudget;
      testmode = fiberStandards.testmode;
      direction = fiberStandards.direction;
      testcordreference = fiberStandards.testcordreference;
      connectortype = fiberStandards.connectortype;
      wavelengthdetails = fiberStandards.wavelengthdetails;
      cordtypes = fiberStandards.testcordtypes;
      multiCordTypes = fiberStandards.refCordLossList;
    }

    let cabletypes =
      test.cablebrand && cablebrands
        ? cablebrands.find(x => x.id === test.cablebrand.id)
        : null;
    if (
      test.cablebrand &&
      test.cablebrand.name.toLowerCase().includes("generic")
    ) {
      disableRefractiveIndex = false;
    } else {
      disableRefractiveIndex = true;
    }
    cabletypes =
      cabletypes && cabletypes.cabletypedetails
        ? cabletypes.cabletypedetails
        : null;
    let cableparts =
      test.cabletype && cabletypes
        ? cabletypes.find(x => x.id === test.cabletype.id)
        : null;
    this.cableType = cableparts ? cableparts.type : null;
    test.flux = test.flux && this.cableType !== "SM" ? test.flux : false;
    cableparts =
      cableparts && cableparts.cablepartdetails
        ? cableparts.cablepartdetails
        : null;
    let appDetails = [];
    let stdDetails = [];
    // filter groups based on cabletypeName when limit method type is cabling standard
    if (
      test.limitmethodtype &&
      test.cabletype &&
      test.limitmethodtype.name == "Cabling Standards"
    ) {
      fiberstdgroups = fiberstdgroups.filter(standardDetailsObj => {
        let o = standardDetailsObj.standarddetails.filter(obj => {
          let m = obj.lengthdetails.filter(
            o =>
              o.name === test.cabletype.name &&
              (o.length != null ||
                o.lossbudgetlow != null ||
                o.lossbudgethigh != null)
          );
          if (m.length) {
            return true;
          } else {
            return false;
          }
        });
        if (o.length) {
          return true;
        } else {
          return false;
        }
      });

      if (test.group) {
        let standarddDetails = fiberstdgroups
          ? fiberstdgroups.find(x => x.id === test.group.id)
          : null;
        // filter standards based on cabletypeName
        if (
          standarddDetails &&
          standarddDetails.standarddetails &&
          test.cabletype.name
        ) {
          standarddDetails = standarddDetails.standarddetails.filter(obj => {
            let m = obj.lengthdetails.filter(
              o =>
                o.name === test.cabletype.name &&
                (o.length != null ||
                  o.lossbudgetlow != null ||
                  o.lossbudgethigh != null)
            );
            if (m.length) {
              return true;
            } else {
              return false;
            }
          });
          stdDetails = standarddDetails ? standarddDetails : [];
        }
      }
    }

    // filter groups based on cabletypeName when limit method type is application
    if (
      test.limitmethodtype &&
      test.cabletype &&
      test.limitmethodtype.name == "Applications"
    ) {
      fiberappgroups = fiberappgroups.filter(applicationDetailsObj => {
        let o = applicationDetailsObj.applications.filter(obj => {
          let m = obj.lengthdetails.filter(
            o =>
              o.name === test.cabletype.name &&
              (o.length != null ||
                o.lossbudgetlow != null ||
                o.lossbudgethigh != null)
          );
          if (m.length) {
            return true;
          } else {
            return false;
          }
        });
        if (o.length) {
          return true;
        } else {
          return false;
        }
      });

      if (test.group) {
        let applicationDetails = fiberappgroups
          ? fiberappgroups.find(x => x.id === test.group.id)
          : null;
        // filter applications based on cabletypeName
        if (
          applicationDetails &&
          applicationDetails.applications &&
          test.cabletype.name
        ) {
          applicationDetails = applicationDetails.applications.filter(obj => {
            let m = obj.lengthdetails.filter(
              o =>
                o.name === test.cabletype.name &&
                (o.length != null ||
                  o.lossbudgetlow != null ||
                  o.lossbudgethigh != null)
            );
            if (m.length) {
              return true;
            } else {
              return false;
            }
          });
          appDetails = applicationDetails ? applicationDetails : [];
        }
      }
    }

    let connectortypevalue =
      test.connectortype && connectortype
        ? connectortype.find(x => x.id === test.connectortype.id)
        : connectortype.find(o => o.id === 1);
    allowEditMaxLength = !test.measurelength;
    allowApplyLength = !test.callimitlength;
    let wavelengths = wavelengthdetails
      ? wavelengthdetails.find(x => x.cabletype === this.cableType)
      : null;
    if (wavelengths && wavelengths.wavelengthvalue) {
      let waveLengthValue = wavelengths.wavelengthvalue;
      this.budgetLossMin = waveLengthValue[0];
      this.budgetLossMax = waveLengthValue[1];
    }
    wavelengths =
      wavelengths && wavelengths.wavelength ? wavelengths.wavelength : null;
    if (test.limitwavelength) {
      if (test.limitwavelength.id === 0) {
        disbleBudgetLossMin = false;
        disbleBudgetLossMax = true;
      } else if (test.limitwavelength.id === 1) {
        (disbleBudgetLossMin = true), (disbleBudgetLossMax = false);
      } else {
        disbleBudgetLossMin = false;
        disbleBudgetLossMax = false;
      }
    }
    let isConvertedToFeet = false;
    if (!this.state.isConvertedToFeet) {
      isConvertedToFeet = true;
      test.maxlength =
        lengthMeasurementUnit == "feet"
          ? Math.round((test.maxlength / 0.3048) * 100) / 100
          : test.maxlength;
    }
    this.setState({
      lossBudget,
      fiberappgroups,
      cablebrands,
      fiberstdgroups,
      testmode,
      direction,
      testcordreference,
      connectortype,
      wavelengthdetails,
      cordtypes,
      multiCordTypes,
      cabletypes,
      cableparts,
      appDetails: appDetails || [],
      stdDetails: stdDetails || [],
      disbleBudgetLossMin,
      disbleBudgetLossMax,
      allowEditMaxLength,
      allowApplyLength,
      wavelengths,
      disableRefractiveIndex,
      test,
      hasResult,
      tabs,
      isConvertedToFeet,
      testHasResultWithMetaData
    });
  };

  componentWillUnmount() {
    this.props.resetForm();
  }
}

export default withStyles(styles)(EditFiberTests);



// WEBPACK FOOTER //
// ./src/components/job/editfiber/index.js